import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import { addDoors } from 'rangeConfig/billy/behaviours/addDoors';
import {
  filterDoorHeights,
  filterDoorTypes
} from 'rangeConfig/billy/filters/mainMenuProductFilters';
import dragAndDropDoorsBehavior from 'rangeConfig/billy/behaviours/dragAndDropDoors';
import removeAllHingedDoorsFromScene from 'rangeConfig/shared/behaviors/removeAllHingedDoorsFromScene';
import { noProductsWithTypesInScene } from 'rangeConfig/shared/rules/noneOptionSelectedRules';

export const doorsProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  categories: [
    {
      id: 'doors-h1920',
      products: [
        { path: 'type', value: ProductType.BILLY_DOOR_ASM },
        { path: 'communicatedDimensions.height', value: 1920 }
      ],
      categoryTitle:
        'storageone.height communicatedDimensionsLocalized.height communicatedDimensionsLocalized.unit'
    },
    {
      id: 'doors-h970',
      products: [
        { path: 'type', value: ProductType.BILLY_DOOR_ASM },
        { path: 'communicatedDimensions.height', value: 970 }
      ],
      categoryTitle:
        'storageone.height communicatedDimensionsLocalized.height communicatedDimensionsLocalized.unit'
    },
    {
      id: 'doors-h350',
      products: [
        { path: 'type', value: ProductType.BILLY_DOOR_ASM },
        { path: 'communicatedDimensions.height', value: 350 }
      ],
      categoryTitle:
        'storageone.height communicatedDimensionsLocalized.height communicatedDimensionsLocalized.unit'
    }
  ],
  behaviors: {
    productClicked: [addDoors],
    productDropped: [dragAndDropDoorsBehavior]
  },
  cluster: [],
  sortOrder: [{ path: 'designText', reverse: true }],
  productFilters: [filterDoorTypes, filterDoorHeights],
  noneOption: {
    title: 'storageone.productListNoHingedDoorsOptionTitle',
    subtitle: 'storageone.productListNoHingedDoorsOptionSubtitle',
    behaviors: { removeProducts: [removeAllHingedDoorsFromScene] },
    selected: noProductsWithTypesInScene([ProductType.BILLY_DOOR_ASM])
  }
};
